import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Breadcrumbs' })({
    root: {
        color: '#8E8E8E',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        padding: '8px 12px',
        borderRadius: 8,
        background: '#F8F8F8'
    },
    separator: {
        width: 16,
        height: 16
    },
    ol: {
        whiteSpace: 'nowrap',
        flexWrap: 'nowrap',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    link: {
        color: 'inherit',
        transition: 'color 0.2s',
        ['&:hover']: {
            color: '#F5726A'
        }
    }
});
